/**
 * Textos da "Conferência no portal da plataforma" (E172.F7.T03, GUS-230 B1.3, GUS-216), na mesa
 * da equipe. No portal atendido o sistema consulta a página sozinho e confere os hashes do
 * comprovante (E174.F1, ADR-0125); nos demais, a pessoa abre o endereço de verificação, confere o
 * registro e anota o que a página informou. Nada se presume: a falha de acesso não é negação, e
 * sem registro nada se afirma.
 */
export const ptBRConferenciaNoPortal = {
  titulo: 'Conferência no portal da plataforma',
  carregando: 'Carregando a conferência no portal…',
  tentarDeNovo: 'Tentar de novo',
  erro: {
    indisponivel: 'Não foi possível carregar ou registrar a conferência. Tente novamente.',
    sem_permissao: 'A conferência no portal é da equipe que atende o caso.',
    nao_encontrado: 'Caso não encontrado.',
    invalida: 'O registro está incompleto para o estado escolhido. Confira os campos.',
    nao_aplicavel_com_registro:
      'O material traz endereço ou código de verificação: a conferência se aplica.',
    instante_no_futuro: 'O instante da consulta está no futuro.',
    print_sem_consulta: 'O print só acompanha uma consulta tentada.',
    print_de_tipo_nao_aceito: 'O print precisa ser PNG, JPEG ou PDF.',
    print_acima_do_teto: 'O print passa de 10 MB.',
  },
  alvo: {
    titulo: 'O que conferir',
    endereco: 'Endereço de verificação',
    origem: {
      comprovante: 'impresso no comprovante',
      codigo_lido: 'lido do código da página',
    },
    codigo: 'Código',
    codigoNoEndereco: 'O código está no endereço: é a página do registro.',
    codigoForaDoEndereco:
      'O endereço não traz o código: confira se a página aberta é a do registro.',
    semConexaoSegura: 'Endereço sem conexão segura (http).',
    dominio: 'Domínio',
    codigosLidos: {
      confere: 'Os códigos lidos das páginas são do mesmo domínio.',
      diverge: 'Um código lido das páginas aponta para outro domínio. Confira antes de registrar.',
      sem_codigo_lido: 'Nenhum código lido das páginas aponta um endereço.',
    },
    envelope: 'Envelope',
    plataforma: 'Plataforma',
    documentos: 'Documentos abrangidos',
    semDocumentos: 'Nenhuma peça em PDF examinada ainda.',
    situacao: {
      com_endereco: 'O material traz o endereço de verificação.',
      so_codigo: 'O material traz só o código, sem o endereço. Informe o endereço onde consultou.',
      sem_registro:
        'O material não traz endereço nem código de verificação. Registre a conferência como não aplicável.',
    },
  },
  estado: {
    consistente: 'Consistente',
    divergente: 'Divergente',
    indisponivel: 'Indisponível',
    nao_executada: 'Não executada',
    nao_aplicavel: 'Não aplicável',
  },
  estadoNoFormulario: {
    consistente: 'A página confirmou o registro',
    divergente: 'A página diverge do material',
    indisponivel: 'A página não respondeu (erro, tempo esgotado, acesso)',
    nao_executada: 'Não consultei',
    nao_aplicavel: 'Não se aplica (sem registro no material)',
  },
  resultado: {
    confere: 'Confere',
    diverge: 'Diverge',
    nao_informado: 'Não informado pela página',
  },
  registradas: {
    titulo: 'Conferências registradas',
    nenhuma: 'Nenhuma conferência registrada ainda.',
    vigente: 'Vigente',
    consultadoEm: 'Consultado em',
    registradaEm: 'Registrada em',
    enderecoInformado: 'endereço informado por quem consultou',
    campos: 'Campos informados pela página',
    noPortal: 'Na página',
    noMaterial: 'No material',
    motivo: 'Motivo',
    verPrint: 'Ver o print',
    semPrint: 'Sem print',
    // E187.F1 (item 6 do Anderson, 29/10): como o documento diz, sem "automática".
    automatica: 'Consulta do sistema',
    respostaGuardada: 'Resposta da página guardada',
  },
  // E180.F2 (GUS-254 item 3): a consulta automática já registrada é o feito; registrar à mão vira
  // correção facultativa.
  feitaPeloSistema:
    'Consulta feita pelo sistema e já considerada nas prévias. Registrar outra conferência é facultativo.',
  corrigir: 'Corrigir',
  recolher: 'Recolher',
  // E203.F5.T04: a automática consistente numa linha, na mesa.
  conferidoEm: 'Conferido no portal em {data}',
  formulario: {
    titulo: 'Registrar a conferência',
    estado: 'Resultado da consulta',
    endereco: 'Endereço consultado',
    codigo: 'Código consultado (opcional)',
    consultadoEm: 'Quando consultou',
    fuso: 'no fuso deste computador',
    campo: 'Campo',
    noPortal: 'O que a página informou',
    noMaterial: 'O que o material traz',
    resultado: 'Confronto',
    adicionarCampo: 'Adicionar campo',
    removerCampo: 'Remover',
    motivo: 'Motivo',
    print: 'Print da página (PNG, JPEG ou PDF, opcional)',
    registrar: 'Registrar conferência',
    registrando: 'Registrando…',
    registrada: 'Conferência registrada.',
  },
} as const;
